import { Component } from 'preact'
import ConfigurationPanel from './ConfigurationPanel'
import ContentHelpfulnessPreview from './ContentHelpfulnessPreview'
import Header from '../header'
import AlertComponent from '../ui-components/Alert'

export class ContentHelpfulnessManager extends Component {
  constructor (props) {
    super()
    const visibility = { visibility: Object.assign({}, this.getDefaultState().visibility, props.configuration.visibility) }
    this.state = Object.assign({}, this.getDefaultState(), { indicator: props.configuration.indicator }, visibility, props.phrases)
    this.saveUri = '/helpfulness/configuration'
    this.phraseUri = '/phrase/edit'
    this.phrases = {
      defaultMessage: {
        key: 'topic.helpfulness.text',
        value: props.phrases.defaultMessage
      },
      successMessage: {
        key: 'topic.helpfulness.thanks',
        value: props.phrases.successMessage
      },
      indicatorLabel: {
        key: 'topic.helpfulness.indicator',
        value: props.phrases.indicatorLabel
      }
    }
  }

  getDefaultState () {
    return {
      indicator: false,
      visibility: {
        answers: false,
        articles: false,
        questions: false,
        discussions: false
      }
    }
  }

  save () {
    const data = {
      indicator: this.state.indicator,
      visibility: this.state.visibility
    }
    this.sendXHRequest(data)

    const updatedPhrases = Object.keys(this.phrases).filter((phrase) => this.phrases[phrase].value !== this.state[phrase])

    updatedPhrases.forEach((phrase) => {
      const phraseData = {
        category: 'Forum',
        message: this.phrases[phrase].key,
        translation: this.state[phrase]
      }
      this.updatePhrase(phraseData)
    })
  }

  sendXHRequest (data, xhr = new window.XMLHttpRequest()) {
    xhr.addEventListener('readystatechange', (e) => this.onReadyStateChangeHandler(e), false)
    xhr.open('POST', this.saveUri, true)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xhr.setRequestHeader('X-Csrf-Token', document.getElementById('csrftoken').value)
    xhr.send(JSON.stringify(data))
  }

  updatePhrase (data, xhr = new window.XMLHttpRequest()) {
    let queryParam = Object.keys(data).reduce((currentVal, key) => {
      return `${currentVal}${key}=${data[key]}&`
    }, '?')
    queryParam = queryParam.substring(0, queryParam.length - 1)
    xhr.addEventListener('readystatechange', (e) => this.onReadyStateChangeHandler(e), false)
    xhr.open('GET', this.phraseUri + queryParam, true)
    xhr.send()
  }

  onReadyStateChangeHandler (evt) {
    if (evt.target.readyState === 4) {
      if (evt.target.status === 200) {
        this.props.successCallback()
      } else {
        this.props.errorCallback()
      }
    }
  }

  render (props, state) {
    let configuration = state
    const phrases = {
      'topic.helpfulness.text': configuration.defaultMessage,
      'topic.helpfulness.thanks': configuration.successMessage,
      'topic.helpfulness.indicator': configuration.indicatorLabel
    }
    return (
      <div>
        <Header title={'Content Helpfulness'} saveCallback={() => this.save()} />
        {props.alertComponent}
        <div className={'content-helpfulness-manager'}>
          <ConfigurationPanel
            configuration={configuration}
            updatePhrase={(key, value) => this.setState({ [key]: value })}
            setValue={(value, field) => this.setState({ [field]: value })}
            setIndicator={() => this.setState({ indicator: !configuration.indicator })}
            setVisibility={(visibility) => this.setState({ visibility: Object.assign({}, this.state.visibility, visibility) })} />
          <div className='content-helpfulness_preview'>
            <ContentHelpfulnessPreview
              phrases={phrases}
              showIndicator={configuration.indicator}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default (props) => <AlertComponent {...props} component={ContentHelpfulnessManager} />
